export enum ActionType {
  CLEAR_SKETCH = "CLEAR_SKETCH"
}

interface IClearSketch {
  type: ActionType.CLEAR_SKETCH
}

export type Action = IClearSketch;
